import { Action, createTypedHooks, createStore, action } from "easy-peasy"
import { Colour } from "../data-models/colour"
import { Inventory } from "../data-models/inventory"
import { User } from "../data-models/user"

type StitchBeanStore = {
    user: User
    colours: Colour[]
    inventory: Inventory[]
    isLoggedIn: boolean
    setUser: Action<StitchBeanStore, User>
    setLoggedIn: Action<StitchBeanStore, boolean>
    setColours: Action<StitchBeanStore, Colour[]>
    setInventory: Action<StitchBeanStore, Inventory[]>
    addInventory: Action<StitchBeanStore, Inventory>,
    updateInventory: Action<StitchBeanStore, Inventory>
}

const typedHooks = createTypedHooks<StitchBeanStore>();

export const useStoreState = typedHooks.useStoreState;
export const useStoreActions = typedHooks.useStoreActions;
export const GetStore = () => {
    return createStore<StitchBeanStore>({
        user: {
            id: '',
            name: '',
            emailAddress: '',
            refreshToken: ''
        },
        colours: [],
        inventory: [],
        isLoggedIn: false,
        setUser: action((state, user) => {
            state.user = user;
        }),
        setLoggedIn: action((state, loggedIn) => {
            state.isLoggedIn = loggedIn;
        }),
        setColours: action((state, colours) => {
            state.colours = colours;
        }),
        setInventory: action((state,inventory) => {
            state.inventory = inventory;
        }),
        addInventory: action((state, newInventory) => {
            state.inventory = [...state.inventory, newInventory];
        }),
        updateInventory: action((state, inventory) => {
            state.inventory = state.inventory.map(inv => {
                if( inv.id === inventory.id){
                    return inventory;
                }
                else {
                    return inv;
                }
            })
        })
    });
}

export default StitchBeanStore